import { loadStripe } from '@stripe/stripe-js';
import { config } from '../config';
import * as stripeJs from '@stripe/stripe-js';
import { Theme } from '@mui/material/styles';

export const stripePromise = loadStripe(config.stripeKey);

export const stripeCustomFont = [
    {
        cssSrc: 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700&display=swap"',
    },
] as Array<stripeJs.CssFontSource>;

export const createStripeFormAppearance = (
    theme: Theme,
    palette: Theme['palette'] = theme.palette
): stripeJs.Appearance => {
    const stripePalette = palette as Theme['palette'] & {
        border?: {
            focused?: string;
        };
    };
    const inputFontSize = theme.typography.body2.fontSize?.toString() ?? '14px';
    const labelTypography = theme.typography as typeof theme.typography & {
        label2?: {
            fontSize?: string | number;
            fontWeight?: string | number;
        };
        label3?: {
            fontSize?: string | number;
            fontWeight?: string | number;
        };
    };

    return {
        theme: palette.mode === 'light' ? 'stripe' : 'night',
        labels: 'above',
        variables: {
            fontFamily: theme.typography.fontFamily,
            borderRadius: `${theme.shape.borderRadius}px`,
            colorBackground: palette.background.paper,
            colorPrimary: palette.primary.main,
            colorText: palette.text.primary,
            colorTextSecondary: palette.text.secondary,
            colorTextPlaceholder: palette.text.disabled,
            colorDanger: palette.error.main,
            colorIconCardError: palette.error.main,
            colorIconCardCvcError: palette.error.main,
            focusBoxShadow: 'none',
        },
        rules: {
            '.Input::placeholder': {
                fontSize: inputFontSize,
                boxShadow: 'none',
            },
            '.Input:focus': {
                border: `1px solid ${stripePalette.border?.focused ?? palette.primary.main}`,
                boxShadow: 'none',
            },
            '.Input--invalid': {
                border: `1px solid ${palette.error.main}`,
                boxShadow: 'none',
            },
            '.Input': {
                fontSize: inputFontSize,
                boxShadow: 'none',
            },
            '.Label': {
                fontSize:
                    labelTypography.label2?.fontSize?.toString() ??
                    inputFontSize,
                color: palette.text.secondary,
                fontWeight:
                    labelTypography.label2?.fontWeight?.toString() ??
                    theme.typography.fontWeightMedium?.toString() ??
                    '500',
                marginBottom: theme.spacing(1),
            },
            '.Error': {
                color: palette.error.main,
                fontSize:
                    labelTypography.label3?.fontSize?.toString() ??
                    inputFontSize,
                fontWeight:
                    labelTypography.label3?.fontWeight?.toString() ??
                    theme.typography.fontWeightMedium?.toString() ??
                    '500',
                marginTop: theme.spacing(0.5),
            },
        },
    };
};

export const stripeFormOptions = {
    wallets: {
        applePay: 'never',
        googlePay: 'never',
    },
    terms: {
        card: 'never',
    },
    fields: {
        billingDetails: {
            address: {
                country: 'never',
                postalCode: 'never',
            },
        },
    },
} as stripeJs.StripePaymentElementOptions;
